'use client'

import type { CardType } from './types'
import { ASSETS_BASE_URL } from '@/constants'

import { Container, Row } from 'react-bootstrap'

import { ClickableButton } from '@/components/buttons'
import { handleOpenPdf } from '@/utils'

type CardFeesAndChargesProps = {
  title?: string
  subtext?: string
  imgSrc?: string
  cardType: CardType
}

export const CardFeesAndCharges = ({
  title = 'Eligibility and requirements',
  subtext = 'Find out who can apply and what you’ll need to get started.',
  imgSrc = '',
  cardType
}: CardFeesAndChargesProps) => {
  // Docs URLs
  const ARBM_Cash_Back_TC_BM = `${ASSETS_BASE_URL}assets/files/ARBM_Cash_Back_T_and_C_BM_8c847d53d8.pdf`
  const ARBM_Cash_Back_TC_ENG = `${ASSETS_BASE_URL}assets/files/ARBM_Cash_Back_TC_ENG_bc01b5ff5b.pdf`
  const ARBM_Priority_Pass_TC_ENG = `${ASSETS_BASE_URL}assets/files/ARBM_Priority_Pass_T_and_C_ENG_July_2026_9e3a35abb4.pdf`
  const ARBM_Priority_Pass_TC_BM = `${ASSETS_BASE_URL}assets/files/ARBM_Priority_Pass_T_and_C_BM_July_2026_160fdb5d35.pdf`
  const Credit_Card_PDS_BM = `${ASSETS_BASE_URL}assets/files/Credit_Card_PDS_BM_v1_30681966f5.pdf`
  const Credit_Card_PDS_ENG = `${ASSETS_BASE_URL}assets/files/Credit_Card_PDS_ENG_v1_7a87138caf.pdf`
  const Credit_Card_i_TnC_Finalised_ENG = `${ASSETS_BASE_URL}assets/files/Credit_Card_i_Tn_C_Finalised_ENG_b594776ef8.pdf`
  const Credit_Card_i_TnC_Finalised_BM = `${ASSETS_BASE_URL}assets/files/Credit_Card_i_Terms_and_Conditions_BM_092026_a14a76ac28.pdf`
  const Application_Form_Eng = `${ASSETS_BASE_URL}assets/files/CC_ENG_FORM_JUNE_2026_0fc3aa3e1b.pdf`
  const Application_Form_BM = `${ASSETS_BASE_URL}assets/files/CC_BM_FORM_260826_7de9a562f7.pdf`
  const Credit_Card_Maintenance_Form = `${ASSETS_BASE_URL}assets/pdf/cards/Credit_Card_Maintenance_Form.pdf`

  return (
    <section id="card-fees-and-charges" className="values section h-100 px-3">
      <Container className="d-flex flex-column items-center">
        <Row className="mb-5 text-center" style={{ color: 'var(--alrajhi-black)' }}>
          <h2 data-aos="fade-up" className="feature-title mb-0">
            {title}
          </h2>
          <span data-aos="fade-up">{subtext}</span>
          <div className="image-container mt-5" style={{ overflowX: 'auto', padding: 0 }}>
            <img src={imgSrc} alt="Table Image" />
          </div>
        </Row>
        <Row
          className="link-button-row-pf pt-5 justify-content-center"
          data-aos="fade-left"
          data-aos-delay="200"
        >
          <ClickableButton
            text="<span>Credit Card-<i>i</i><br/> Application Form (English)</span>"
            onClick={() => handleOpenPdf(Application_Form_Eng)}
          />
          <ClickableButton
            text="<span>Credit Card-<i>i</i><br/> Application Form<br/>(Bahasa Melayu)</span>"
            onClick={() => handleOpenPdf(Application_Form_BM)}
          />
          <ClickableButton
            text="<span>Credit Card-<i>i</i><br/> Terms and<br/> Conditions (English)</span>"
            onClick={() => handleOpenPdf(Credit_Card_i_TnC_Finalised_ENG)}
          />

          <ClickableButton
            text="<span>Credit Card-<i>i</i><br/> Terms and<br/> Conditions (Bahasa Melayu)</span>"
            onClick={() => handleOpenPdf(Credit_Card_i_TnC_Finalised_BM)}
          />

          <ClickableButton
            text="<span>Cashback Terms <br/>and Conditions (English)</span>"
            onClick={() => handleOpenPdf(ARBM_Cash_Back_TC_ENG)}
          />
          <ClickableButton
            text="<span>Cashback Terms <br/>and Conditions<br/>(Bahasa Melayu)</span>"
            onClick={() => handleOpenPdf(ARBM_Cash_Back_TC_BM)}
          />
          {/* only for Signature Card */}
          {cardType === 'signature' && (
            <ClickableButton
              text="Priority Pass Lounge<br/>Terms and Conditions<br/>(English)"
              onClick={() => handleOpenPdf(ARBM_Priority_Pass_TC_ENG)}
            />
          )}
          {cardType === 'signature' && (
            <ClickableButton
              text="Priority Pass Lounge<br/>Terms and Conditions<br/>(Bahasa Melayu)"
              onClick={() => handleOpenPdf(ARBM_Priority_Pass_TC_BM)}
            />
          )}
          <ClickableButton
            text="<span>Product Disclosure<br/> Sheet (English)</span>"
            onClick={() => handleOpenPdf(Credit_Card_PDS_ENG)}
          />
          <ClickableButton
            text="<span>Product Disclosure<br/> Sheet (Bahasa Melayu)</span>"
            onClick={() => handleOpenPdf(Credit_Card_PDS_BM)}
          />
          <ClickableButton
            text="<span>Credit Card-<i>i</i><br/> Maintenance Form</span>"
            onClick={() => handleOpenPdf(Credit_Card_Maintenance_Form)}
          />
        </Row>

        {/* Second Row of Docs */}
      </Container>
    </section>
  )
}
